/**
 * Preference: scroll the glyph overview when the editing glyph stack changes.
 * Default on — toggle via Editing View → View menu.
 */
import { isOverviewFollowEnabled, setOverviewFollowEnabled } from './window-ui-state';
export function isOverviewFollowStackScrollEnabled() {
    return isOverviewFollowEnabled();
}
export function setOverviewFollowStackScrollEnabled(enabled) {
    setOverviewFollowEnabled(enabled);
    window.dispatchEvent(new CustomEvent('overviewFollowStackScrollChanged', {
        detail: { enabled }
    }));
}
export function toggleOverviewFollowStackScrollEnabled() {
    const next = !isOverviewFollowStackScrollEnabled();
    setOverviewFollowStackScrollEnabled(next);
    return next;
}
